import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { TaskManagedAttributesNames } from '@bringg/common-utils';

function getStore() {
	return getRootEnv().dashboardSdk.sdk.v2.taskManagedAttributes;
}

export async function loadManagedAttributeForTask(taskId: number) {
	await getStore().loadByIds([taskId], { useCache: true });
}

export function getManagedAttributeByName<T>(taskId: number, name: TaskManagedAttributesNames): T | undefined {
	return getStore().get(taskId)?.[name] as T | undefined;
}

export const ManagedAttributesService = {
	loadManagedAttributeForTask,
	getManagedAttributeByName
};
